import { defineApiQuery } from "utils/queries";
import { protectedGet } from "./restUtil";

// [DEPRECATED]
export function getPaymentMethods(): Promise<ListResponse<PaymentMethod>> {
  return new Promise((resolve, reject) => {
    protectedGet("/payment/methods", undefined, resolve, reject);
  });
}

export const paymentMethodsQuery = defineApiQuery<
  ListResponse<PaymentMethod>,
  void,
  void,
  PaymentMethod[]
>({
  key: "/payment/methods",
  select: data =>
    // Filter out Apple Pay, because saved Apple Pay can't be used for online purchases - see:
    // https://docs.stripe.com/apple-pay/apple-pay-recurring#set-up-off-session-payments
    data.list.filter(method => method.wallet?.type !== "apple_pay"),
});
export interface PaymentMethod {
  id: string;
  card: Card;
  wallet: { type: string } | null;
}

export interface Card {
  brand: string;
  exp_month: number;
  exp_year: number;
  last4: string;
}
export interface ListResponse<T> {
  list: T[];
  total: number;
}
